import React from 'react'
import { TStepProps, TValidator } from '@health-zelas/quiz'
import { Button, Container, Grid, Heading, Paragraph } from "@health-zelas/delta"
import { TextInput } from '@packages/components'

import { isEmailValid } from '../../utils/isEmailValid'
import { isPhoneValid } from '../../utils/isPhoneValid'

import { OptInGroup } from '../../components/OptInGroup'
import ProgressBar from "../../components/ProgressBar"
import Step from "../../components/Step"

import * as S from './PersonalData.styles'

const PersonalData: React.FC<TStepProps> = ({
  navigateToNextStep,
  navigateToPrevStep
}) => {
  const className = 'dados'

  const fieldIsValid = (fieldName: string, value: string) => {
    if (!value) {
      return `${fieldName} é obrigatório`
    }

    return `${fieldName} inválido`
  }

  return (
    <Step>
      <Container css={{ paddingBottom: '$lg' }}>
        <Grid>
          <Grid.Item colSpans={{ sm: 12, md: 6, lg: 5 }}>
            <div>
              <ProgressBar title="Dados pessoais" fill={2} />
              <Heading
                as="h1"
                size="lg"
                weight="bold"
                css={{
                  marginBottom: '$xxs'
                }}
              >
                Primeiro, complete suas informações
              </Heading>
              <Paragraph
                size="lg"
                color="$neutralDark"
                lineHeight="distant"
                css={{
                  marginBottom: '$md'
                }}
              >
                Assim, após a simulação, entraremos em contato com você para tirar dúvidas e conversar mais sobre os planos.
              </Paragraph>
            </div>
          </Grid.Item>

          <Grid.Item colStarts={{ md: 7 }} colEnds={{ md: 13 }}>
            <div>
              <Heading
                size="sm"
                weight="bold"
                css={{
                  color: '$neutralDark',
                  marginBottom: '$xxs'
                }}
              >
                Por favor, insira seus dados:
              </Heading>

              <TextInput
                label='Nome'
                name='firstname'
                id='firstname'
                className={className}
                required
                validator={{
                  func: (fieldValue = '') => {
                    const [, lastName] = fieldValue.split(' ')

                    if(!lastName){
                      return false
                    }

                    return !!fieldValue
                  },
                  msg: (fieldValue = '') => {
                    if(!fieldValue){
                      return 'Nome é obrigatório'
                    }

                    return 'Preencha o nome e sobrenome'
                  }
                } as TValidator}
              />

              <S.InputGroup>
                <TextInput
                  label='Telefone'
                  required
                  name='phone'
                  helperText='O contato será feito por ligação ou WhatsApp.'
                  id='telefone_preenchimento_dados'
                  className={className}
                  mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                  validator={{
                    func: (fieldValue) => isPhoneValid(fieldValue as string),
                    msg: (fieldValue = '') => fieldIsValid('Número', fieldValue)
                  } as TValidator}
                />

                <TextInput
                  label='E-mail'
                  id='email_preenchimento_dados'
                  className={className}
                  name='email'
                  required
                  validator={{
                    func: (fieldValue) => isEmailValid(fieldValue as string),
                    msg: (fieldValue = '') => fieldIsValid('E-mail', fieldValue)
                  } as TValidator}
                />
              </S.InputGroup>

              <div style={{ marginTop: '24px' }}>
                <OptInGroup />
              </div>

              <S.ButtonGroup>
                <Button
                  variant="tertiary"
                  size="large"
                  id="voltar_dados"
                  className={className}
                  onClick={navigateToPrevStep}
                >
                  Voltar
                </Button>

                <Button
                  size="large"
                  id="continuar_dados"
                  className={className}
                  onClick={navigateToNextStep}
                >
                  Continuar
                </Button>
              </S.ButtonGroup>
            </div>
          </Grid.Item>
        </Grid>
      </Container>
    </Step>
  )
}

export default PersonalData
